<div class="layout-topbar">
    <div class="topbar-left">
        <a
            #menubutton
            tabindex="0"
            class="menu-button p-trigger"
            (click)="onMenuButtonClick()"
        >
            <i class="pi pi-chevron-left"></i>
        </a>
        <img
            class="horizontal-logo"
            [routerLink]="['/']"
            [src]="layoutService.horizontalLogo()"
            alt="diamond-layout"
        />
        <span class="topbar-separator"></span>
        <img
            [src]="layoutService.iconLogo()"
            class="h-full mobile-logo"
            alt="diamond-layout"
        />

        <app-organization-select></app-organization-select>

        <!-- For debug -->
        <!--        <app-button-->
        <!--            class="ml-3"-->
        <!--            [text]="true"-->
        <!--            label="Offline dev"-->
        <!--            (clickEvent)="isOffline.set(!isOffline())"-->
        <!--        ></app-button>-->

        @if (isAllowed['madoAccount.read']() || isAllowed['madoAccount.create']() || isAllowed['madoAccount.update']() || isAllowed['madoAccount.delete']()) {
            <app-organization-year-select class="ml-1"></app-organization-year-select>
        }
    </div>

    <app-sidebar></app-sidebar>
    <div class="layout-mask modal-in"></div>

    <div class="topbar-right">
        @if (offlineDb.isDownloading()) {
            <div class="flex gap-small align-items-center mr-3">
                <i
                    class="pi pi-spin pi-sync"
                    style="font-size: 1rem"
                    [pTooltip]="'common.syncingData' | translate"
                    tooltipPosition="bottom"
                ></i>
                @if (!layoutService.isHorizontal()) {
                    <span>{{ 'common.syncingData' | translate }}</span>
                }
            </div>
        }

        @if (offlineDb.delayedDb.hasAny() && !isOffline()) {
            <app-delayed-requests class="mr-3"></app-delayed-requests>
        }

        <ul class="topbar-menu">
            @let settings = topbarStore.systemSettings();
            @if (settings?.topbarVideocall) {
                <li class="microphone">
                    <a tabindex="0" (click)="onMicrophoneClick()" class="p-trigger">
                        <i class="pi pi-video"></i> <!--TODO: microphone icon-->
                    </a>
                </li>
            }
            @if (settings?.topbarFullscreen) {
                <li class="fullscreen">
                    <a tabindex="0" (click)="onFullscreenClick()" class="p-trigger">
                        <i class="pi pi-window-maximize"></i> <!--TODO: fullscreen icon-->
                    </a>
                </li>
            }

            <!-- settings?.topbarHelp &&  -->
            @if (featureOn.GUIDE && currentGuidePage()) {
                <li class="guide">
                    <a tabindex="0" class="p-trigger" (click)="onGuideClick()">
                        <i class="pi pi-question"></i>
                    </a>
                </li>
            }

            @if (attendanceServices().length) {
                <li class="attendance-item">
                    <a
                        tabindex="0"
                        class="p-trigger"
                        [pTooltip]="'attendance.daily.label' | translate"
                        tooltipPosition="bottom"
                        (click)="openAttendanceCandidates()"
                    >
                        <i class="pi pi-list-check"></i>
                    </a>
                </li>
            }

            <!-- TODO Dočasně vypnuty settingy a vynuceno zobrazení -->
            @if (settings?.topbarSearch || true) {
                <li class="search-item">
                    <a tabindex="0" (click)="onSearchClick()" class="p-trigger">
                        <i class="pi pi-search"></i>
                    </a>
                </li>
            }

            <li class="profile-item static sm:relative">
                <a
                    tabindex="0"
                    pStyleClass="@next"
                    enterFromClass="hidden"
                    enterActiveClass="scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="fadeout"
                    [hideOnOutsideClick]="true"
                    #profileButton
                    style="display: flex; align-items: center; gap: 0.5rem;"
                >
                    <app-avatar
                        [initials]="user()?.initials"
                        [src]="user()?.image"
                        [userSex]="user()?.sex || null"
                    ></app-avatar>
                    <span class="profile-name font-bold">{{ user()?.username || '' }}</span>
                </a>
                <ul
                    class="list-none px-3 py-2 m-0 border-round shadow-2 absolute hidden origin-top w-full sm:w-16rem mt-2 top-auto"
                >
                    <li>
                        <a
                            pRipple
                            class="flex p-2 border-round align-items-center transition-colors transition-duration-150 cursor-pointer"
                            (click)="onProfileClick()"
                        >
                            <i class="pi pi-user mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">{{ 'header.profile' | translate }}</span>
                            </span>
                        </a>
                    </li>
                    <li>
                        <a
                            pRipple
                            class="flex p-2 border-round align-items-center transition-colors transition-duration-150 cursor-pointer"
                            (click)="onSettingsClick()"
                        >
                            <i class="pi pi-cog mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">{{ 'header.settings' | translate }}</span>
                            </span>
                        </a>
                    </li>
                    @if (settings?.topbarUserEmail) {
                        <li>
                            <a
                                pRipple
                                class="flex p-2 border-round align-items-center transition-colors transition-duration-150 cursor-pointer"
                                (click)="onEmailClick()"
                            >
                                <i class="pi pi-envelope mr-3"></i>
                                <span class="flex flex-column">
                                <span class="font-semibold">{{ 'header.email' | translate }}</span>
                            </span>
                            </a>
                        </li>
                    }
                    @if (settings?.topbarUserOffice) {
                        <li>
                            <a
                                pRipple
                                class="flex p-2 border-round align-items-center transition-colors transition-duration-150 cursor-pointer"
                                (click)="onMyOfficeClick()"
                            >
                                <i class="pi pi-calendar mr-3"></i>
                                <span class="flex flex-column">
                                <span class="font-semibold">{{ 'header.myOffice' | translate }}</span>
                            </span>
                            </a>
                        </li>
                    }
                    @if (settings?.topbarUserReports) {
                        <li>
                            <a
                                pRipple
                                class="flex p-2 border-round align-items-center transition-colors transition-duration-150 cursor-pointer"
                                (click)="onRequestsReportsClick()"
                            >
                                <i class="pi pi-volume-up mr-3"></i>
                                <span class="flex flex-column">
                                <span class="font-semibold">{{ 'header.requestsAndReports' | translate }}</span>
                            </span>
                            </a>
                        </li>
                    }
                    @if (settings?.topbarUserReadMessages) {
                        <li>
                            <a
                                pRipple
                                class="flex p-2 border-round align-items-center transition-colors transition-duration-150 cursor-pointer"
                                (click)="onReadMessagesClick()"
                            >
                                <i class="pi pi-comment mr-3"></i>
                                <span class="flex flex-column">
                                <span class="font-semibold">{{ 'header.readMessages' | translate }}</span>
                            </span>
                            </a>
                        </li>
                    }

                    <li>
                        <a
                            pRipple
                            class="flex p-2 border-round align-items-center transition-colors transition-duration-150 cursor-pointer"
                            (click)="refreshOfflineDbs(false)"
                        >
                            <i class="pi pi-sync mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">{{ 'delay-request.sync' | translate }}</span>
                            </span>
                        </a>
                    </li>
                    <li>
                        <a
                            pRipple
                            class="flex p-2 border-round align-items-center transition-colors transition-duration-150 cursor-pointer"
                            (click)="refreshOfflineDbs()"
                        >
                            <i class="pi pi-sync mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">{{ 'delay-request.refresh' | translate }}</span>
                            </span>
                        </a>
                    </li>
                    <li>
                        <hr class="-mx-3 my-2"/>
                    </li>
                    <li>
                        <a
                            pRipple
                            class="flex p-2 border-round align-items-center transition-colors transition-duration-150 cursor-pointer"
                            (click)="logout()"
                        >
                            <i class="pi pi-power-off mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">{{ 'header.logout' | translate }}</span>
                            </span>
                        </a>
                    </li>
                </ul>
            </li>
            <li class="static sm:relative">
                <a
                    tabindex="0"
                    enterFromClass="hidden"
                    enterActiveClass="scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="fadeout"
                    (click)="onNotificationClick()"
                >
                    <i
                        class="pi pi-bell"
                        [style.color]="notificationBellState().color"
                        [@bellRing]="notificationBellState().state"
                        (@bellRing.done)="onAnimationDone()"
                    ></i>
                    @let notificationsCount = topbarStore.totalAttentionCount();
                    @if (notificationsCount > 0) {
                        <span
                            class="topbar-badge"
                            [@badgePulse]="notificationBellState().state"
                        >{{ notificationsCount > 99 ? '99+' : notificationsCount }}</span>
                    }
                </a>
            </li>
        </ul>

        @if (topbarStore.progressData().size > 0) {
            <div class="flex-column gap progress-container">
                @for (item of topbarStore.progressData().values(); track item.progressId) {
                    <div class="flex gap align-items-center">
                        @switch (item.type) {
                            @case ('export') {
                                <app-icon icon="pi-download"></app-icon>
                            }
                            @case ('import') {
                                <app-icon icon="pi-upload"></app-icon>
                            }
                        }
                        <div class="flex-column flex-1 gap-small">
                            <span class="font-size-small">
                                {{ 'common.progress.' + item.type | translate }} {{ 'common.progress.entity.' + item.entity | translate }}
                            </span>
                            @if (item.name) {
                                <span class="font-size-small">
                                    {{ item.name }}
                                </span>
                            }
                            <p-progress-bar
                                [value]="item.percent"
                                [showValue]="false"
                                [style]="{ height: '4px' }"
                            ></p-progress-bar>
                            <label class="font-size-x-small">
                                {{ item.percent }}% {{ 'common.progress.state.completed' | translate }} ({{item.done}}/{{item.total}})
                            </label>
                            @if (item.progressLabel) {
                                <label class="font-size-x-small">
                                    {{ item.progressLabel }}
                                </label>
                            }
                        </div>
                    </div>
                }
            </div>
        }

    </div>
</div>
